// ⌘K's recent picks (SEARCH-NOTIF): the last 20 things picked from the palette in a company, in
// this browser (`localStorage companyos.palette.{id}`), newest first, as `kind:id`. They are sent
// with every palette query; the server resolves them under the caller's current access (a pick
// the caller may no longer see simply does not come back) and returns them first.
const KEY = (companyId: string) => `companyos.palette.${companyId}`;
export const PALETTE_RECENT_MAX = 20;

const PAIR = /^[a-z]+:[0-9a-f-]{36}$/;

export function readPaletteRecent(companyId: string): string[] {
  try {
    const raw = window.localStorage.getItem(KEY(companyId));
    const list = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(list)
      ? list.filter((x): x is string => typeof x === "string" && PAIR.test(x))
      : [];
  } catch {
    return [];
  }
}

export function recordPaletteRecent(companyId: string, kind: string, id: string): string[] {
  const pair = `${kind}:${id}`;
  const next = [pair, ...readPaletteRecent(companyId).filter((p) => p !== pair)].slice(
    0,
    PALETTE_RECENT_MAX,
  );
  try {
    window.localStorage.setItem(KEY(companyId), JSON.stringify(next));
  } catch {
    // Storage blocked: nothing is remembered.
  }
  return next;
}
